export const PROBLEM_TYPE_TITLE_BY_CODE = {
    INTRINSIC: 'ВНУТРЕННИЕ ХАР-КИ',
    DELIVERY: 'ДОСТАВКА',
    MATCH: 'СООТВЕТСТВИЕ',
    VALUE: 'ЦЕННОСТЬ',
    SERVICE: 'ОБСЛУЖИВАНИЕ',
    INFO: 'ИНФОРМАЦИЯ',
    EXTERNAL: 'ВНЕШНИЕ ФАКТОРЫ',
    BEHAVIORAL: 'ПОВЕДЕНЧЕСКИЕ ФАКТОРЫ',
    TEMPORAL: 'ВРЕМЕННЫЕ ФАКТОРЫ',
    CONTEXT: 'КОНТЕКСТ ИСПОЛЬЗОВАНИЯ',
    COMPETITIVE: 'КОНКУРЕНТНОЕ СРАВНЕНИЕ',
    EXPECTATION_GAP: 'РАЗРЫВ ОЖИДАНИЙ',
} as const;

type ProblemTypeCode = keyof typeof PROBLEM_TYPE_TITLE_BY_CODE;

const hasProblemTypeTitle = (value: string): value is ProblemTypeCode => {
    return Object.prototype.hasOwnProperty.call(PROBLEM_TYPE_TITLE_BY_CODE, value);
};

export const getProblemTypeTitle = (value: string | null | undefined): string | null => {
    if (typeof value !== 'string') {
        return null;
    }

    const normalizedValue = value.trim();
    if (!normalizedValue) {
        return null;
    }

    const normalizedCode = normalizedValue.toUpperCase();
    if (hasProblemTypeTitle(normalizedCode)) {
        return PROBLEM_TYPE_TITLE_BY_CODE[normalizedCode];
    }

    return normalizedValue;
};
